import React, { useEffect, useState } from "react";
import { Typography, FormLabel, TextField } from "@material-ui/core";
import TableView from "../../../CustomComponent/TableView";
import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";

function QuestionPickTable({
  classes,
  formDetails,
  handleFormChange,
  selectedSubject,
  setSelectedSubjectSLength,
}) {
  const style = [
    {
      height: "maxh67",
      style: "viewtable",
      footer: false,
      //   setPageSize: setPageSize,
      //   pageSize: pageSize,
      //   rowCount: rowCount,
      //   handlePageChange: handlePageChange,
      //   page: page,
      paginationMode: "server",
    },
  ];

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [sections, setSections] = useState([]);
  const [sectionWiseCount, setSectionWiseCount] = useState(
    formDetails?.section_count || [],
  );

  const filteredRows = sections.map((sec, index) => ({
    id: sec.id,
    srno: index + 1,
    section_name: sec.section_name,
    section_id: sec.id,
    subject_name: sec?.subject?.subject_name,
    subject_id: sec?.subject?.id,
  }));

  const handleQuestionChange = (row, field, value) => {
    const numValue = Number(value);

    setSectionWiseCount((prev) => {
      const existingIndex = prev.findIndex(
        (item) =>
          item.section_id === row.section_id &&
          item.subject_id === row.subject_id,
      );

      let updatedRow =
        existingIndex !== -1
          ? { ...prev[existingIndex] }
          : {
              section_id: row.section_id,
              subject_id: row.subject_id,
              total_question_count: 0,
              pick_question_count: 0,
            };

      // update field
      updatedRow[field] = numValue;

      // validation
      //   if (updatedRow.pick_question_count > updatedRow.total_question_count) {
      //     toast.warning(
      //       "Pick Question Count cannot be greater than Total Question Count",
      //     );
      //     return prev;
      //   }

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = updatedRow;
        return updated;
      }

      return [...prev, updatedRow];
    });
  };

  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 20,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "subject_name",
      headerName: "Subject",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "section_name",
      headerName: "Section",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 180,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      valueGetter: (params) =>
        params.value.charAt(0).toUpperCase() + params.value.slice(1),
    },
    {
      field: "total_question_count",
      headerName: "Total Question",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 170,
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => (
        <TextField
          type="number"
          variant="outlined"
          size="small"
          value={
            sectionWiseCount.find(
              (item) =>
                item.section_id === params.row.section_id &&
                item.subject_id === params.row.subject_id,
            )?.total_question_count || ""
          }
          onChange={(e) =>
            handleQuestionChange(
              params.row,
              "total_question_count",
              e.target.value,
            )
          }
        />
      ),
    },
    {
      field: "pick_question_count",
      headerName: "Pick Question",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 170,
      sortable: false,
      disableColumnMenu: true,

      renderCell: (params) => (
        <TextField
          type="number"
          variant="outlined"
          size="small"
          disabled={
            !sectionWiseCount.find(
              (item) =>
                item.section_id === params.row.section_id &&
                item.subject_id === params.row.subject_id,
            )?.total_question_count
          }
          value={
            sectionWiseCount.find(
              (item) =>
                item.section_id === params.row.section_id &&
                item.subject_id === params.row.subject_id,
            )?.pick_question_count || ""
          }
          style={{
            opacity: !sectionWiseCount.find(
              (item) =>
                item.section_id === params.row.section_id &&
                item.subject_id === params.row.subject_id,
            )?.total_question_count
              ? 0.5
              : 1,
          }}
          onChange={(e) =>
            handleQuestionChange(
              params.row,
              "pick_question_count",
              e.target.value,
            )
          }
        />
      ),
    },
  ];

  const fetchSections = async () => {
    try {
      const response = await axios.post(
        // `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/all/main?page=${
        //   pageNumber + 1
        // }&limit=${size}&search=${search}`,
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/subjects_id`,
        {
          subjects_id: selectedSubject,
        },
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        },
      );
      setSections(response.data.subjects_section);
      setSelectedSubjectSLength(response.data.subjects_section.length);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchSections();
  }, [selectedSubject]);
  useEffect(() => {
    handleFormChange("section_count", sectionWiseCount);
  }, [sectionWiseCount]);

  return (
    <div
      className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
    >
      <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
        <Typography
          className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
          variant="h6"
          display="inline"
        >
          Section-wise Question Count{" "}
        </Typography>
        <TableView columns={columns} rows={filteredRows} Heading={style} />
      </div>
    </div>
  );
}

export default QuestionPickTable;
